import React from 'react';
import { Field } from 'react-final-form';
import FormSelect from 'Shared/components/FormComponents/FormSelect';

import Collapsed from '../Collapsed';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

export default function CompletedFilter() {
  const { tr } = useTranslation();

  const completedFilterOptions = Object.freeze([
    { label: tr('perform.search.sidebar.completed.options.all'), value: 'all' },
    { label: tr('perform.search.sidebar.completed.options.completed'), value: 'completed' },
    { label: tr('perform.search.sidebar.completed.options.not_completed'), value: 'not_completed' },
  ]);

  return (
    <Collapsed title={tr('perform.search.sidebar.completed.title')}>
      <Field name="completed" type="select" options={completedFilterOptions} component={FormSelect} blurInputOnSelect />
    </Collapsed>
  );
}
